import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CreateChancel, InputMain } from 'components';
import { FindErrorItem, FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';

const ACTION_TYPE = 'CONNECT_ZOOM';
export const ConnectZoom = () => {
    const { close } = useModal();
    const { handleSubmit, control, setError, clearErrors } = useForm();
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);

    useEffect(() => {
        clearErrors();
    }, []);

    useEffect(() => {
        if (success) {
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success, backError]);
    const handleCreate = () => {
        dispatch(systemActions.connectZoom());
    };

    return (
        <div style={{ width: 400 }}>
            <div className="office-ally-header" style={{ marginBottom: 12 }}>
                <div className="office-ally-header-icons">
                    <div>
                        <img src={Images.logoSmall} alt="" />
                    </div>
                    <img src={Images.compareArrows} alt="arrow" />
                    <div>
                        <img src={Images.zoom} alt="zoom" />
                    </div>
                </div>
                <p>Connect to Zoom</p>
            </div>

            <p className="modal-header-sub">
                You will be redirected to Zoom to authorize your account. After granting permission, you’ll be automatically redirected back
                to TherapyLake.
            </p>

            <div style={{ marginTop: 12 }}>
                <CreateChancel
                    onCreate={handleCreate}
                    loader={!!loader.length}
                    create={'Connect'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth={'100%'}
                />
            </div>
        </div>
    );
};
